import { jsxs, jsx } from "react/jsx-runtime";
const ImportSchemaIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx("path", { d: "M505.7 509C506.448 509.956 507.405 510.729 508.496 511.261C509.588 511.793 510.786 512.069 512 512.069C513.214 512.069 514.412 511.793 515.504 511.261C516.596 510.729 517.552 509.956 518.3 509L630.3 367.3C634.4 362.1 630.7 354.4 624 354.4H549.9V347H550V271H549.9V120C549.9 115.6 546.3 112 541.9 112H481.9C477.5 112 473.9 115.6 473.9 120V354.3H400C393.3 354.3 389.6 362 393.7 367.2L505.7 509Z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M908 876V600C908 582.3 893.1 568 874.7 568H149C130.6 568 116 582.3 116 600V876C116 893.7 130.6 908 149 908H874.7C893.1 908 908 893.7 908 876ZM664 640V836H836V640H664ZM424 836V640H600V836H424ZM184 640V836H360V640H184Z"
    }
  )
] });
export {
  ImportSchemaIcon
};
